import { assertTargetSpec, } from '@cards/engine';
function checked(spec) {
    assertTargetSpec(spec);
    return Object.freeze(spec);
}
/** Cards-owned ergonomic builders; runtime enumeration remains engine-owned. */
export function unitTarget(input) {
    return checked({
        kind: 'unit',
        ...input,
        ...(input.cardTypes === undefined ? {} : { cardTypes: Object.freeze([...input.cardTypes]) }),
    });
}
export function cardTarget(input) {
    return checked({ kind: 'card', ...input, zones: Object.freeze([...input.zones]) });
}
export function cellTarget(input) {
    return checked({ kind: 'cell', ...input });
}
export function tableTarget(input) {
    return checked({ kind: 'table', ...input });
}
export function playerTarget(input) {
    return checked({ kind: 'player', ...input });
}
export function modeTarget(input) {
    const options = input.options.map((option) => Object.freeze(typeof option === 'string' ? { id: option } : { ...option }));
    return checked({ ...input, kind: 'mode', options: Object.freeze(options) });
}
export function targetStep(stepId, spec, onInvalidAtResolution) {
    if (typeof stepId !== 'string' || stepId.length === 0) {
        throw new Error('targetStep: stepId должен быть непустой строкой');
    }
    assertTargetSpec(spec);
    return Object.freeze({
        stepId,
        spec,
        ...(onInvalidAtResolution === undefined ? {} : { onInvalidAtResolution }),
    });
}
export function planningTargets(steps, onInvalidAtResolution = 'all_or_nothing') {
    if (typeof steps !== 'function') {
        const ids = steps.map(({ stepId }) => stepId);
        if (ids.some((id) => typeof id !== 'string' || id.length === 0)
            || new Set(ids).size !== ids.length) {
            throw new Error('planningTargets: steps требует уникальные непустые stepId');
        }
        for (const step of steps)
            assertTargetSpec(step.spec);
    }
    return Object.freeze({ steps, onInvalidAtResolution });
}
//# sourceMappingURL=builders.js.map